import * as yup from 'yup';

import { getEmptyErrorMessage, testValidRange } from 'coreOld/yup';

const MIN_DECIMALS = 1;
const MAX_DECIMALS = 5;

export const companyPartDetailsFormSchema = yup.object().shape({
  packageType: yup.string().nullable(),
  uomId: yup.string().nullable(),
  salesUom: yup.string().nullable(),
  packageUom: yup.string().nullable(),
  externalUom: yup.string().nullable(),
  minimumQuantity: yup.string().nullable(),
  orderIncrement: yup
    .number()
    .nullable()
    .min(0, 'Sales order increment must be greater than 0')
    .typeError('Sales order increment must be greater than 0')
    .required(getEmptyErrorMessage('Sales order increment')),
  pkgUnits: yup
    .number()
    .nullable()
    .min(0, 'Package quantity must be greater than 0')
    .typeError('Package quantity must be greater than 0'),
  bomPriceDecimals: yup
    .number()
    .nullable()
    .required(getEmptyErrorMessage('BoM price decimals'))
    .typeError(`Number of decimals must be between ${MIN_DECIMALS} and ${MAX_DECIMALS}`)
    .test(...testValidRange('Number of decimals', MIN_DECIMALS, MAX_DECIMALS)),
  quotePriceDecimals: yup
    .number()
    .nullable()
    .typeError(`Number of decimals must be between ${MIN_DECIMALS} and ${MAX_DECIMALS}`)
    .test(...testValidRange('Number of decimals', MIN_DECIMALS, MAX_DECIMALS, false)),
  manufacturerOrderIncrement: yup
    .number()
    .nullable()
    .min(0, 'Vendor order increment must be greater than 0')
    .typeError('Vendor order increment must be greater than 0')
    .required(getEmptyErrorMessage('Vendor order increment')),
  className: yup.string().nullable(),
  taaStatus: yup.string().nullable(),
  mfgPartStatus: yup.string().nullable(),
  companyPartStatus: yup.string().nullable(),
  replacementPart: yup.string().nullable(),
  partBaseCode: yup.string().nullable(),
  pricingGroup1: yup.string().nullable(),
  pricingGroupDescription1: yup.string().nullable(),
  pricingGroup2: yup.string().nullable(),
  pricingGroupDescription2: yup.string().nullable(),
  pricingGroup3: yup.string().nullable(),
  pricingGroupDescription3: yup.string().nullable(),
  pricingGroup4: yup.string().nullable(),
  pricingGroupDescription4: yup.string().nullable(),
  pricingGroup5: yup.string().nullable(),
  pricingGroupDescription5: yup.string().nullable(),
  part: yup.string().nullable(),
  manufactureId: yup.string().nullable(),
});
